export function scrollToTop() {
    window.history.scrollRestoration = "manual"
    window.scrollTo(0, 0); 
}
